import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/7. Non-food in.png'

const TotalFoodIn = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={`Kg ${makeSum(submissions, 'non_food_in')}`}
            text="Total Non-food In"
        />
    );
}

export default TotalFoodIn;